import { render, staticRenderFns } from "./TabsInPillsWithBrandColor.vue?vue&type=template&id=657547d1&"
import script from "./TabsInPillsWithBrandColor.vue?vue&type=script&lang=ts&"
export * from "./TabsInPillsWithBrandColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports